import React from "react";
import {Button,Modal} from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import compose from 'recompose/compose';
import { ReducerType } from "../../../redux/reducer.type";
import {withTranslation} from "react-i18next";
import logo from "../../../assets/img/wayfayer-big.png"
import {RegulationPropsType} from "./regulation.type";
class Regulation extends React.Component<RegulationPropsType, any> {
    state = {
        reload: false,
        loading: false
    };

    componentDidMount(): void {
        require( "../../../assets/styles/antd/import/modalRegulations.scss");
    }

    handleClick = () => {
        const {user,} = this.props;
        this.props.acceptRegulations(user.activeWorkspace.uuid)
    };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        const {
            t,
            isMobile, regulation_modal
        } = this.props;
        return (
            <Modal
                width={isMobile ? '90vw' : 800}
                title={t("regulation")}
                visible={regulation_modal === 1}
                onOk={this.handleClick} onCancel={() => {} }
                className={"regulations"}
                footer={[
                    <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleClick}>
                        {t("accept")}
                    </Button>,
                ]}
            >
                <div className={'row'}>
                    <div className={'col-12 text-center'}>
                        <img src={logo} alt={"Logo Wayfayer"}/> <br />
                        <h3 className={"mt-3"}>{t("regulation")}</h3>
                    </div>
                    <div className={'col-12 mt-2 regulations'}>
                        <ol>
                            <li>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
                                <ol>
                                    <li>It is a long established fact that a reader will be distracted by the readable content of</li>
                                    <li>It is a long established fact that a reader will be distracted by the readable content of</li>
                                    <li>It is a long established fact that a reader will be distracted by the readable content of</li>
                                </ol>
                            </li>
                            <li>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</li>
                            <li>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
                                <ol>
                                    <li>It is a long established fact that a reader will be distracted by the readable content of</li>
                                    <li>It is a long established fact that a reader will be distracted by the readable content of</li>
                                    <li>It is a long established fact that a reader will be distracted by the readable content of</li>
                                </ol>
                            </li>
                        </ol>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: ReducerType) => ({settings: state.settings,user: state.user,isMobile: state.settings.isMobileView,});

export default withRouter(compose<RegulationPropsType, any>(
    connect(mapStateToProps),
    withTranslation("workspaces")
)(Regulation)) as React.ComponentClass<{}>;
